import {Pipe, PipeTransform} from '@angular/core';

import {FormFieldType} from "../enums/form-field-type.enum";

@Pipe({name: 'fieldTypeCanBeSensitive'})
export class FieldTypeCanBeSensitivePipe implements PipeTransform {
  transform(value: string): boolean {
    const fieldType = value as FormFieldType;
    return fieldType === FormFieldType.TEXT ||
      fieldType === FormFieldType.EMAIL ||
      fieldType === FormFieldType.TEXTAREA ||
      fieldType === FormFieldType.DATE;
  }
}
